// Core
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
`;

export const MainNavigationContainer = styled.div`
  width: 100%;
`;
